<template>
    <div>
        <Stepper
            v-if="currentStep"
            :steps="stepSequence"
            :selectableOptions="selectableOptions"
            :stepNumber="stepNumber"
            ref="stepper"
            id="stepper"
            :title="getTitle"
            :currentStep="currentStep"
            :continueBtn="{
                show: currentStep.continue,
                disabled:
                    !experienceValid ||
                    !emailValid ||
                    !validClientInfo ||
                    !capacityValid ||
                    !offSiteLocationValid,
            }"
            :saveBtn="{
                show: currentStep.saveBtn,
                disabled:
                    !experienceValid ||
                    !emailValid ||
                    !validClientInfo ||
                    !capacityValid ||
                    !offSiteLocationValid,
            }"
            :paymentBtn="{
                loading: loading,
            }"
            :formLoadingProp="form.processing"
            :apiLoading="apiLoading && currentStep?.showLoading"
            @jumpToStep="jumpToStep($event)"
            @nextStep="nextStep()"
            @continueBtn="continueBtn()"
            @paymentBtn="$refs.payment.submitManualCard()"
            @backStep="backStep()"
            @submit="submit()"
            @reset="$_data_reset()"
            @saveInnerForm="saveInnerForm()"
            :flat="flat"
            :relative="relative"
            :permanent="permanent"
            :cardBody="cardBody"
            ><!--<template #header>
                <v-container class="pa-8" v-if="event?.lesson">
                    <ConfirmGuestLesson
                        class="custom-btn"
                        disabled
                        :lesson="event?.lesson"
                    />
                </v-container>
                <v-divider v-if="event?.lesson" inset class="mx-auto" />
                <SoliInstruments
                    label="Instrument"
                    hideDetails="auto"
                    :multiple="false"
                    :showOther="true"
                    autocomplete
                    pill
                    style="max-width: 155px"
                />
            </template>-->
            <template v-slot:[step.name] v-for="step in selectableOptions">
                <component
                    v-if="currentStep.name == step.name"
                    :key="step.name"
                    :is="step.comp"
                    v-bind="{ ...step.props() }"
                    v-on="step.on"
                    v-model="form[step.name]"
                    :class="step.classes"
                ></component>
            </template>
        </Stepper>
        <div v-for="alert in alerts" :key="alert?.subtitle">
            <SoliChoice
                v-if="alert"
                ref="alert"
                :title="alert.title"
                :subtitle="alert.subtitle"
                :button1="alert.button1"
                :button2="alert.button2"
                :warning="alert.warning"
                @option1="alert.option1()"
                @option2="alert.option2()"
                :permanent="alert.permanent"
                ><template>
                    <v-list dense>
                        <v-list-item
                            v-for="conflict in futureBookingConflict"
                            :key="conflict.starts_at"
                            ><small class="soli-grey">{{
                                `· ${conflict.type} on ${globalMomentDate(
                                    conflict.starts_at
                                )}`
                            }}</small></v-list-item
                        >
                    </v-list>
                </template></SoliChoice
            >
        </div>
    </div>
</template>

<script>
import Stepper from "../Stepper.vue";
import BookingData from "../../Mixins/Booking/BookingData";
import BookingComponents from "../../Mixins/Booking/BookingComponents";
import BookingOptions from "../../Mixins/Booking/BookingOptions";
import BookingControls from "../../Mixins/Booking/BookingControls";
import BookingAlerts from "../../Mixins/Booking/BookingAlerts";
import BookingAPIs from "../../Mixins/Booking/BookingAPIs";
import BookingSource from "../../Mixins/Booking/BookingSource";
import BookingSelect from "../../Mixins/Booking/BookingSelect";
import BookingStudentService from "../../Mixins/Booking/BookingStudentService";
import globalMoment from "../../Mixins/GlobalMoment.js";
import ConfirmGuestLesson from "../Booking/ConfirmGuestLesson.vue";
import confetti from "canvas-confetti";

export default {
    mixins: [globalMoment],
    components: {
        Stepper,
        ConfirmGuestLesson,
    },
    props: {
        errors: {},
        event: {},
        bookingSource: {},
        relationships: {
            type: Array,
            default: null,
        },
        flat: {
            type: Boolean,
            default: false,
        },
        relative: {
            type: Boolean,
            default: false,
        },
        permanent: {
            type: Boolean,
            default: false,
        },
        cardBody: {
            type: Boolean,
            default: true,
        },
    },
    mixins: [
        BookingOptions,
        BookingComponents,
        BookingData,
        BookingControls,
        BookingAlerts,
        BookingAPIs,
        BookingSource,
        BookingSelect,
        BookingStudentService,
    ],
    data() {
        return {
            form: this.$inertia.form({
                billingUser: null,
                purchaseOption: null,
                assessmentType: null,
                location: null,
                repeating: null,
                student: null,
                online: null,
                duration: null,
                instrument: null,
                teacher: null,
                startTime: null,
                startDate: null,
                room: null,
                type: null,
                experience: null,
                confirm: null,
                event_title: null,
                eventType: null,
                address: null,
                somethingNew: null,
                selectClass: null,
                templateEvent: null,
                credit: null,
                substitutePass: null,
                courtesyReschedule: false,
                capacity: null,
                occurrences: null,
                offSiteLocation: null,
                isSelfServe: null,
                //registrationOnly: null,
                //email: null,
            }),
            loading: false,
            assignment: null,
            availability: null,
            purchaseOption: null,
            conflicts: [],
            stepSequence: [],
            experienceValid: true,
            capacityValid: true,
            offSiteLocationValid: true,
            emailValid: true,
            validClientInfo: true,
            //getTitle: this.loadTitle(),
        };
    },
    methods: {
        /**
         * Limit to booking sources
         */
        loadInitialEventData(event, maintainSelection = []) {
            this.$_source_handleNewBooking();
            this.$_source_handleMyScheduleBooking(event);
            this.$_source_handleCalendarBooking(event);
            this.$_source_handleCalendarDragDropRescheduleBooking(event);
            this.$_source_handleRescheduleBooking(event);
            //this.$_source_handleGroupEventRescheduleBooking(event);
            this.$_source_handleSelfServeBooking(event);
            this.$_source_handleGuestSessionBooking(event);
            this.$_source_completeGuestSessionBooking(event);
        },
        saveInnerForm() {
            let valid = this.$refs.clientInfo.$refs.form.validate();
            console.log(valid + "... saving");
        },
        continueBtn() {
            this.stepNumber++;
            if (!this.bookingSource.isGuestSession) return;
            this.$refs.stepper.$refs.form.submitForm();
        },
        submit() {
            let postUrl = "/lesson";
            if (this.bookingSource.isGuestSession) {
                postUrl = "/get-started/hold-appointment";
            }

            this.form
                .transform((form) => ({
                    ...form,
                    // originalEvent represents direct reschedule
                    // will be cancelled if rescheduling directly from a lesson
                    starts_at: this.$_data_lessonStart.format("lll"),
                    duration: form.duration,
                    room_id: form.room?.id,
                    location_id: form.location?.id,
                    student_id: form.student?.id ?? null,
                    futureEvents: form.repeating ?? form.type?.recurring,
                    repeating: form.repeating ?? form.type?.recurring,
                    user_id: form.teacher?.id ?? this.$page.props.auth.user.id,
                    instrument_id: form.instrument?.id ?? null,
                    type: this.getEventType,
                    conflicts: this.conflicts,
                    availability_id: this.availability?.id,
                    assignment_id: this.assignment?.id,
                    status: this.form.type?.reschedule ? "Early-cancel" : null,
                    recurrence_end: this.assignment?.recurrence?.ends_at,
                    recurrence_id: form.repeating
                        ? this.event?.recurrence_id
                        : null,
                    noConflict: this.noConflict,
                    online: form.type?.hold ? false : form.online,
                    purchase_option: this.form.purchaseOption?.id,
                    billingUser: this.form.billingUser?.id,
                    isSelfServe: !!this.form.isSelfServe,
                    requireAssignment:
                        form.type?.hold ||
                        (form.type?.event &&
                            (form.address ||
                                form.templateEvent?.registration_event))
                            ? false
                            : form.repeating,
                    groupEvent: this.$_data_bookingGroupEvent
                        ? {
                              title: form.templateEvent?.title,
                              event_type: form.templateEvent?.event_type,
                              access: this.getGroupEventTitle,
                              id: this.getGroupEventId,
                              new_lesson_id: form.selectClass?.id,
                              original_lesson_id:
                                  this.event?.id || this.form.credit?.id,
                          }
                        : null,
                    rrule_freq: form.templateEvent?.rrule_freq ?? "WEEKLY",
                    freq_human: form.templateEvent?.freq_human ?? "Weeks", // this is fine for now, but should be updated to be more dynamic
                    rrule_int:
                        form.templateEvent?.rrule_int ??
                        (this.biweeklyConfirm ? "2" : "1"),
                    studentRescheduleGroupEvent: Boolean(
                        !this.$page.props.staffView &&
                            this.$_data_bookingGroupEvent
                    ),
                    assessmentType: this.form.assessmentType?.name,
                    credit: this.form.credit?.id,
                    notes: this.form.experience,
                    capacity: this.form.capacity ?? 1,
                    occurrences: this.form.occurrences
                        ? this.form.occurrences
                        : null,
                    //offSiteLocation: this.form.offSiteLocation ?? [],
                }))
                .post(postUrl, {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.panel = [];
                        if (this.$refs.stepper) {
                            this.$refs.stepper.$refs.form.dialog = false;
                        }
                        this.$emit("success", this.$_data_lessonStart.hours());
                        if (!this.bookingSource.isGuestSession) {
                            /*const scalar = 3;
                            const summer = confetti.shapeFromText({
                                text: "😎",
                                scalar,
                            });
                            const palm = confetti.shapeFromText({
                                text: "🌴",
                                scalar,
                            });
                            const melon = confetti.shapeFromText({
                                text: "🍉",
                                scalar,
                            });*/

                            confetti({
                                /*shapes: [summer, palm, melon],
                                scalar,*/
                                particleCount: 100,
                                spread: 70,
                                origin: { y: 0.6 },
                            });
                        }
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        if (errors.contactSupport) return;
                        if (errors.soliError) return;
                        if (errors.date) {
                            this.showFutureConflictAlert(errors);
                        } else {
                            let futureConflicts = [];
                            Object.values(errors).forEach((e) => {
                                futureConflicts.push(JSON.parse(e));
                            });
                            this.showFutureConflictAlert(futureConflicts);
                            this.showAssessmentConflictAlert(futureConflicts);
                        }
                    },
                });
        },
        /*loadTitle() {
            if (!this.currentStep) return;
            if (this.currentStep.header) return this.currentStep.title;
            if (this.currentStep.confirm) {
                let type = this.form.type?.reschedule
                    ? "Reschedule"
                    : this.form.type?.name;
                return `Confirm ${type}`;
            }
            if (!this.form.type?.reschedule) {
                return `Book ${this.form.type?.name}`;
            }
            if (this.form.credit?.group_event) return "Reschedule Class";
            if (this.currentStep.credit || this.form.type?.reschedule) {
                let typeName =
                    this.form.type?.originalType == "Weekly Lesson"
                        ? "Lesson"
                        : this.form.type?.originalType;
                return `Reschedule ${typeName}`;
            }
            return `Reschedule ${this.form.type.name}`;
        },*/
    },
    computed: {
        getTitle() {
            if (!this.currentStep) return;
            if (this.currentStep.header) return this.currentStep.title();
            if (this.currentStep.confirm) {
                let type = this.form.type?.reschedule
                    ? "Reschedule"
                    : this.form.type?.name;
                return `Confirm ${type}`;
            }
            if (!this.form.type?.reschedule) {
                return `Book ${this.form.type?.name}`;
            }
            if (this.form.credit?.group_event) return "Reschedule Class";
            if (this.currentStep.credit || this.form.type?.reschedule) {
                let typeName =
                    this.form.type?.originalType == "Weekly Lesson"
                        ? "Lesson"
                        : this.form.type?.originalType;
                return `Reschedule ${typeName}`;
            }
            return `Reschedule ${this.form.type.name}`;
        },
        selectableOptions() {
            return this.stepSequence.filter((e) => !!e.step);
        },

        getEventType() {
            let event = this.event || this.form.credit;
            if (this.form.type?.pending) return "Pending";
            if (this.form.substitutePass) return "Reschedule";
            if (event?.group_event && this.form.type.reschedule) {
                return "Event";
            }
            if (
                this.form.type.reschedule &&
                event.type?.name == "Weekly Lesson"
            ) {
                return "Reschedule";
            }

            return this.form.type?.name ?? null;
        },
        getGroupEventId() {
            return this.event?.group_event?.id ?? this.form.templateEvent?.id;
        },
        getGroupEventAccess() {
            return (
                this.event?.group_event?.access ??
                this.form.templateEvent?.access
            );
        },
    },
    mounted() {
        this.loadInitialEventData(this.event);
    },
    beforeDestroy() {
        this.$_data_reset(true);
    },
    watch: {
        currentStep(step) {
            if (step?.callback) step.callback();
        },
    },
};
</script>

<style></style>
